
const GeoAPI = (() => {
	let API;
	let _currentSearchType;
	let _currentStatus;
	let defaultGeo;
	let assetURL;
	let currentDate = Number(Math.floor(new Date().valueOf() / 1000));
	const topGeoIp = document.querySelector(".top-geo-ip[data-api-key]");
	const LS = window.localStorage;
	const apiKey = topGeoIp ? topGeoIp.getAttribute("data-api-key") : "";
	const geolocationAPIPath = "https://api.ipgeolocation.io/ipgeo?apiKey=" + apiKey;
	const lsPrefix = "mtn-v0-2_";
	const availableCountries = ["united states"];
  let failedFile = false;
	const avaliableStates = ["ca"];
	const eventHandlers = {};

	const searchStatus = {
		WAITING: "waiting",
		HAS_DELIVERY: "hasDelivery",							// OK
		NO_ZIP_DELIVERY: "noZipDelivery", 				// GEO IP and we do not deliver to the ZIP
		NO_STATE_DELIVERY: "noStateDelivery", 		// Don’t deliver to this zip, but zip in CA
		NO_COUNTRY_DELIVERY: "noCountryDelivery", // GEO IP from outside US
		GEO_BLOCKED: "geoBlocked", 								// GEO IP is blocked
		NO_ZIP:"noZip"
	};

	const searchType = {
		AUTO: "auto",
		MANUAL: "manual"
	};

	let geo = {
		country: "",
		state: "",
		stateAbbr: "",
		city: "",
		zip: "",
		zone: "",
		zoneDelivery:false,
		stateOk:false,
	};

	const init = () => {
		defaultGeo = { ...geo };
		_currentStatus = searchStatus.WAITING;
		assetURL = window._assetURL;
	};

	const load = () => {
		loadUserGEO();
		if (geo.zip) {
			verifyResult(); // TODO - just appply in some cases
		} else {
			detectAutomaticaly();
		}

		return API;
	}

	const detectAutomaticaly = () => {
		geo = { ...defaultGeo };
		zipAPIFailed = false;
		_currentSearchType = searchType.AUTO;

		fetch(geolocationAPIPath)
			.then((response) => {
				let place;
				if (response.ok) {
					geoJSON = response.json().then((geoJSON) => {
            geo.country = geoJSON.country_name;
            geo.state = geoJSON.state_prov;
            geo.city = geoJSON.city;
            geo.zip = geoJSON.zipcode;
						verifyResult();
					}).catch(verifyResult);
				} else verifyResult();
			}).catch(verifyResult);

			return API;
	};

	const findAreaByZip = (zip) => {
		geo = { ...defaultGeo };
		geo.zip = zip;

		saveUserGEO();

		verifyResult();
		return API;
	};

  const getNewZones = async () => {
    let data = {};

    await getJSONFile("zip_zones_2024.json").then((response) => {
      data = response
    });

    return data[geo.zip] || null
  }

	const verifyResult = () => {
		if (geo.zip && geo.zip.indexOf("-") !== -1) {
			geo.zip = geo.zip.split("-")[0];
		}
		if (!geo.zip) {
			applyResult();
			return;
		}

		getJSONFile("zip-config.json").then((configFile) => {
			const files = configFile.files;
			for (let i = 0; i < files.length; i ++) {
				let file = files[i];
				let range = file.split("-");
        failedFile = false;
				if (geo.zip >= range[0] && geo.zip <= range[1]) {
					getJSONFile("zip-" + file + ".json").then(async (zips) => {
						let zipItem = zips[geo.zip];

            geo.zone = await getNewZones();

						if (!zipItem || zipItem.length < 2) {
							applyResult({er:"no zip in file " + file});
							return;
						}

						geo.city = zipItem[0];
						geo.zone = geo.zone || zipItem[1];

						getJSONFile("zip-states.json").then((states) => {
							for (let stateAbbr in states) {
									let state = states[stateAbbr];
									if (geo.zip >= state.from && geo.zip <= state.to) {
										geo.stateAbbr = stateAbbr;
										geo.state = state.name;
										geo.country = "united states";

										geo.stateOk = avaliableStates.indexOf(geo.stateAbbr.toLowerCase()) !== -1;
										geo.zoneDelivery = configFile.zips.indexOf(geo.zip) !== -1;

										applyResult();
										return;
									}
							}

							applyResult({er:"no state found"});
						}).catch((er) => applyResult({er:"states loading error"}));

					}).catch(async (er) => {
            failedFile = true;
            geo.zone = await getNewZones();
            applyResult({er: "file range loading error"});
          });

					return;
				}
			}

			applyResult({er:"zip is out of the us"});
		}).catch(() => applyResult({er:"zip-config loading error"}));
	};

	const applyResult = (opt) => {
		if (opt && opt.er)
			console.warn(opt.er);

		if (_currentSearchType !== searchType.AUTO) {
			saveUserGEO();
		}

		determAPIStatus();
		dispatch("update");
	}

	const getJSONFile = (filename) => {
		return new Promise((resolve, reject) => {
			let storageDate = Number(LS.getItem(lsPrefix + 'mod-date'));
			let fileInLS = LS.getItem(lsPrefix + filename);
			let zero = false;
			if (currentDate - storageDate === 0) {
				zero = true;
			}
			if (fileInLS && storageDate && (currentDate - storageDate < 3600) && zero === false && JSON.parse(fileInLS).last_update == "2025-05-28") {
				resolve(JSON.parse(fileInLS));
			} else {
				fetch(assetURL + filename + "?rnd=" + Math.round(Math.random() * 1000000))
					.then((response) => {
						if (response.ok) {
							response.json().then((json) => {
								LS.setItem(lsPrefix + filename, JSON.stringify(json));
								LS.setItem(lsPrefix + 'mod-date', currentDate);
								resolve(json);
							}).catch(er => reject(er))
						} else {
							reject(response.status);
						}
					}).catch(er => reject(er))
			}
		});
	}

	const saveUserGEO = () => {
		LS.setItem(lsPrefix + "userGEO", JSON.stringify(geo));
	};

	const loadUserGEO = () => {
		const item = LS.getItem(lsPrefix + "userGEO")
		geo = item ? JSON.parse(item) : { ...defaultGeo };
	};

	const determAPIStatus = () => {
		if (!geo.zip) {
			_currentStatus = searchStatus.GEO_BLOCKED;
		} else if (availableCountries.indexOf(geo.country.toLowerCase()) === -1 && !failedFile) {
			_currentStatus = searchStatus.NO_COUNTRY_DELIVERY;
		} else if (!geo.stateOk) {
			_currentStatus = searchStatus.NO_STATE_DELIVERY;
		} else if (!geo.zoneDelivery) {
			_currentStatus = searchStatus.NO_ZIP_DELIVERY;
		} else {
			_currentStatus = searchStatus.HAS_DELIVERY;
		}
	};


	const on = (eventType, handler) => {
		if (!eventHandlers.hasOwnProperty(eventType))
			eventHandlers[eventType] = [];

		if (eventHandlers[eventType].indexOf(handler) === -1)
			eventHandlers[eventType].push(handler);

		return API;
	};

	const dispatch = (eventType) => {
		let handlers = eventHandlers[eventType] || [],
			i = 0, length = handlers.length;

		for (i; i < length; i++) {
			handlers[i]({ target: API, eventType: eventType });
		}
	};

	API = {
		load:load,
		on: on,
		findAreaByZip: findAreaByZip,
		get country() { return geo.country },
		get state() { return geo.state },
		get stateAbbr() { return geo.stateAbbr },
		get city() { return geo.city },
		get zip() { return geo.zip },
		get zone() { return geo.zone },
		get zoneDelivery() { return geo.zoneDelivery },
		get stateOk() { return geo.stateOk },
		get searchType() { return searchType },
		get currentSearchType() { return _currentSearchType },
		get currentStatus() { return _currentStatus },
		get searchStatus() { return searchStatus }
	};

	init();
	return API;
})();


document.addEventListener('click', (e) => {
	if (!e.target) return;

	if (!e.target.closest("#top-geo-ip")) {
		const checkbox = document.querySelector('#top-geo-ip-checkbox');

		if (checkbox && checkbox.checked) checkbox.checked = false;
	}
})